import { FormNameEnum } from '@alice-financial/alice-sdk'
import * as React from 'react'
import { PagedForm } from '../../survey/PagedForm'
import { QuestionPage } from '../../survey/types'
import { useOrgId } from '../useOrgId'
import { useCreateOrgFormResponse } from './useCreateOrgFormResponse'
import { useCurrentOrgFormFields, useOrgFormStatus } from './useOrgFormFields'

type PagedOrgFormProps = {
  formName: FormNameEnum
  formVersion: number
  pages: readonly QuestionPage[]
  onCompleteReturnTo?: string
  disableDone?: boolean
}
export const PagedOrgForm = ({
  formName,
  formVersion,
  pages,
  onCompleteReturnTo,
  disableDone,
}: PagedOrgFormProps) => {
  const orgId = useOrgId()
  const surveyStatus = useOrgFormStatus(orgId, formName, formVersion)
  const formFields = useCurrentOrgFormFields(formName, formVersion)
  const { mutateAsync: createFormResponse } = useCreateOrgFormResponse({ formName, formVersion })

  return (
    <PagedForm
      formName={formName}
      formVersion={formVersion}
      pages={pages}
      onCompleteReturnTo={onCompleteReturnTo}
      formFields={formFields}
      createFormResponse={createFormResponse}
      disableDone={disableDone}
      status={surveyStatus}
    />
  )
}
